export default "__VITE_ASSET__dc194ab6__"